/* ============================================================
   MARS JEWELERS — theme.js
   Vanilla JS: mobile menu, smooth anchors, reveal on scroll,
   header state. No frameworks.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Mobile menu toggle ---------- */
  var toggle = document.getElementById('menu-toggle');
  var menu = document.getElementById('mobile-menu');
  var closeBtn = document.getElementById('menu-close');

  function setMenu(open) {
    if (!toggle || !menu) return;
    document.body.classList.toggle('menu-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    menu.setAttribute('aria-hidden', String(!open));
  }

  if (toggle) {
    toggle.addEventListener('click', function () { setMenu(true); });
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', function () { setMenu(false); });
  }
  if (menu) {
    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { setMenu(false); });
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setMenu(false);
  });

  /* ---------- Smooth anchor scrolling ---------- */
  function smoothTo(target) {
    var el = typeof target === 'string' ? document.querySelector(target) : target;
    if (!el) return false;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  // Same-page #anchors
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var href = a.getAttribute('href');
      if (href.length > 1 && smoothTo(href)) {
        e.preventDefault();
        history.replaceState(null, '', href);
      }
    });
  });

  // /#anchors while already on the homepage (avoid a reload)
  document.querySelectorAll('a[href^="/#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (window.location.pathname === '/') {
        var id = a.getAttribute('href').slice(1);
        if (id.length > 1 && smoothTo(id)) {
          e.preventDefault();
          history.replaceState(null, '', id);
        }
      }
    });
  });

  /* ---------- Header state ---------- */
  var header = document.getElementById('site-header');
  function onScroll() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 24);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Reveal on scroll ----------
     FIX 2026-10-23: removed. Scroll-reveal load-in animations were making
     the page feel slow; .reveal is now plain visible content in CSS. */
})();

/* ============================================================
   v2: Shop — cart drawer, product gallery, variants, qty
   ============================================================ */
(function () {
  'use strict';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');

  function setCartOpen(open) {
    if (!drawer || !overlay) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    overlay.hidden = !open;
    document.body.classList.toggle('cart-open', open);
    // retrigger reveal for freshly injected cards
    if (open && 'IntersectionObserver' in window) {
      drawer.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }
  }

  function renderCart(cart) {
    var itemsWrap = drawer.querySelector('[data-cart-items]');
    var countEls = document.querySelectorAll('[data-cart-count]');
    var headerCount = document.querySelector('[data-header-cart-count]');
    var totalEl = drawer.querySelector('[data-cart-total]');

    countEls.forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
    if (headerCount) {
      headerCount.textContent = cart.item_count;
      headerCount.hidden = cart.item_count === 0;
    }
    if (totalEl) totalEl.textContent = money(cart.total_price);

    if (!cart.items.length) {
      itemsWrap.innerHTML = '<p class="cart-drawer-empty">Your cart is empty.</p>';
      return;
    }
    itemsWrap.innerHTML = cart.items.map(function (item, i) {
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-drawer-item-variant">' + esc(item.variant_title) + '</p>' : '';
      var img = item.image
        ? '<img src="' + esc(item.image) + '" alt="' + esc(item.title) + '" width="120" height="120" loading="lazy">' : '';
      return '<div class="cart-drawer-item">' + img +
        '<div class="cart-drawer-info">' +
          '<p class="cart-drawer-item-title">' + esc(item.product_title) + '</p>' + variant +
          '<div class="cart-drawer-qty">' +
            '<button type="button" data-drawer-qty="minus" data-line="' + (i + 1) + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-drawer-qty="plus" data-line="' + (i + 1) + '" aria-label="Increase quantity">+</button>' +
          '</div><br>' +
          '<button type="button" class="quiet-link" data-drawer-remove data-line="' + (i + 1) + '">Remove</button>' +
        '</div>' +
        '<p class="cart-drawer-item-price">' + money(item.final_line_price) + '</p>' +
      '</div>';
    }).join('');
  }

  function refreshCart(openAfter) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (openAfter) setCartOpen(true);
        return cart;
      })
      .catch(function () { /* drawer keeps last state */ });
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function () { refreshCart(true); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { setCartOpen(false); });
  });
  if (overlay) overlay.addEventListener('click', function () { setCartOpen(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setCartOpen(false);
  });

  // Drawer qty + remove (event delegation)
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-drawer-qty]');
      var rmBtn = e.target.closest('[data-drawer-remove]');
      if (qtyBtn) {
        var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
        var delta = qtyBtn.getAttribute('data-drawer-qty') === 'plus' ? 1 : -1;
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var item = cart.items[line - 1];
            if (!item) return null;
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ line: line, quantity: Math.max(0, item.quantity + delta) })
            });
          })
          .then(function () { return refreshCart(false); })
          .catch(function () {});
      } else if (rmBtn) {
        var rline = parseInt(rmBtn.getAttribute('data-line'), 10);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: rline, quantity: 0 })
        }).then(function () { return refreshCart(false); }).catch(function () {});
      }
    });
  }

  // Add to cart from product form -> open drawer
  var productForm = document.querySelector('form[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = productForm.querySelector('[data-add-to-cart]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(productForm)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () { return refreshCart(true); })
        .catch(function () {
          // Fallback: regular form submit if the API fails
          productForm.submit();
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
        });
    });
  }

  /* ---------- Product gallery ---------- */
  var thumbs = document.querySelectorAll('[data-gallery-thumb]');
  var galleryImgs = document.querySelectorAll('[data-gallery-img]');
  function activateGalleryImage(idx) {
    idx = String(idx);
    thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-gallery-thumb') === idx); });
    galleryImgs.forEach(function (img) {
      var active = img.getAttribute('data-gallery-img') === idx;
      img.classList.toggle('is-active', active);
      img.hidden = !active;
    });
  }
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      activateGalleryImage(thumb.getAttribute('data-gallery-thumb'));
    });
  });

  /* ---------- Variant selection ---------- */
  var productJsonEl = document.querySelector('[data-product-json]');
  if (productJsonEl && productForm) {
    var product = JSON.parse(productJsonEl.textContent);
    var variantInput = productForm.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-product-price]');
    var addPriceEl = document.querySelector('[data-add-price]');
    var addBtn = productForm.querySelector('[data-add-to-cart]');
    var saveFlagEl = document.querySelector('[data-save-flag]');
    var variantImagesEl = document.querySelector('[data-variant-images]');
    var variantImages = {};
    try { variantImages = variantImagesEl ? JSON.parse(variantImagesEl.textContent) : {}; } catch (e) {}

    function currentVariant() {
      var selected = {};
      productForm.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var idx = fs.getAttribute('data-option-index');
        var checked = fs.querySelector('input:checked');
        if (checked) selected['option' + (parseInt(idx, 10) + 1)] = checked.value;
      });
      return product.variants.find(function (v) {
        return Object.keys(selected).every(function (k) { return v[k] === selected[k]; });
      });
    }

    function updateVariant() {
      var v = currentVariant();
      if (!v) return;
      if (variantInput) variantInput.value = v.id;
      var priceHtml = money(v.price);
      if (v.compare_at_price > v.price) {
        priceHtml = '<s class="price-was">' + money(v.compare_at_price) + '</s>' + priceHtml;
      }
      if (priceEl) priceEl.innerHTML = priceHtml;
      if (addPriceEl) addPriceEl.textContent = money(v.price);
      if (saveFlagEl) {
        if (v.compare_at_price > v.price) {
          saveFlagEl.textContent = 'Save ' + money(v.compare_at_price - v.price);
          saveFlagEl.hidden = false;
        } else {
          saveFlagEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (!v.available) addBtn.innerHTML = 'Sold out';
      }
      // selected value labels
      productForm.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var label = fs.querySelector('[data-option-selected]');
        var checked = fs.querySelector('input:checked');
        if (label && checked) label.textContent = '— ' + checked.value;
      });
      // specs block values stay in sync with the selected options
      document.querySelectorAll('[data-spec-option]').forEach(function (dd) {
        var fs = productForm.querySelector('[data-option-index="' + dd.getAttribute('data-spec-option') + '"]');
        var checked = fs ? fs.querySelector('input:checked') : null;
        if (checked) dd.textContent = checked.value;
      });
      // switch gallery image to the selected variant's featured image (e.g. color change)
      var vImgId = variantImages[String(v.id)];
      if (vImgId) {
        var target = null;
        galleryImgs.forEach(function (img) {
          if (img.getAttribute('data-image-id') === String(vImgId)) {
            target = img.getAttribute('data-gallery-img');
          }
        });
        if (target !== null) activateGalleryImage(target);
      }
    }

    productForm.querySelectorAll('[data-option-index] input').forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });
    updateVariant();
  }

  /* ---------- Quantity stepper (product page) ---------- */
  var qtyInput = document.querySelector('[data-qty-input]');
  if (qtyInput && productForm) {
    productForm.querySelector('[data-qty-minus]').addEventListener('click', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
    });
    productForm.querySelector('[data-qty-plus]').addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
    });
  }

  /* ---------- v3.7: pause hero video for reduced motion ---------- */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.hero-video-bg').forEach(function (v) {
      v.pause();
      v.removeAttribute('autoplay');
    });
  }

  /* ---------- Customer orders marquee ----------
     FIX 2026-10-23: JS transform driver removed. The marquee is now a CSS
     keyframe drift on desktop (pauses on hover) and a native scroll-snap
     swipe on touch devices — see .orders-marquee in theme.css. */
})();

/* ---------- Pendant builder handoff: pre-fill the quote form ---------- */
(function () {
  var body = document.getElementById('q-body');
  if (!body) return;
  var raw = null;
  try {
    raw = sessionStorage.getItem('mj-pendant-config');
    sessionStorage.removeItem('mj-pendant-config');
  } catch (e) { /* storage unavailable */ }
  if (!raw) return;
  try {
    var c = JSON.parse(raw);
    var msg = 'Pendant builder request — Text: "' + c.text + '", Font: ' + c.font + ', Bail: ' + c.bail + '.\n\n';
    body.value = body.value ? msg + body.value : msg;
  } catch (e) { /* bad payload — leave the form alone */ }
})();

/* ---------- v3.11: product image zoom lightbox (pinch / double-tap / swipe) ---------- */
(function () {
  var main = document.querySelector('[data-gallery-main]');
  var box = document.querySelector('[data-zoom-lightbox]');
  if (!main || !box) return;
  var imgs = Array.prototype.slice.call(main.querySelectorAll('[data-gallery-img]'));
  if (!imgs.length) return;
  var stage = box.querySelector('[data-zoom-stage]');
  var zimg = box.querySelector('[data-zoom-img]');
  var count = box.querySelector('[data-zoom-count]');

  var idx = 0, scale = 1, tx = 0, ty = 0;

  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function apply() {
    zimg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
  }
  function clampPan() {
    var sw = stage.clientWidth, sh = stage.clientHeight;
    var iw = zimg.clientWidth || sw, ih = zimg.clientHeight || sh;
    var maxX = Math.max(0, (iw * scale - sw) / 2 + 40);
    var maxY = Math.max(0, (ih * scale - sh) / 2 + 40);
    tx = clamp(tx, -maxX, maxX);
    ty = clamp(ty, -maxY, maxY);
  }
  function show(i) {
    idx = (i + imgs.length) % imgs.length;
    scale = 1; tx = 0; ty = 0;
    zimg.style.transform = 'none';
    zimg.src = imgs[idx].getAttribute('data-zoom-src') || imgs[idx].src;
    if (count) count.textContent = (idx + 1) + ' / ' + imgs.length;
  }
  function activeIndex() {
    for (var i = 0; i < imgs.length; i++) { if (!imgs[i].hidden) return i; }
    return 0;
  }
  function open() {
    show(activeIndex());
    box.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function close() {
    box.hidden = true;
    document.body.style.overflow = '';
    pointers.clear();
    scale = 1; tx = 0; ty = 0;
  }

  main.addEventListener('click', open);
  box.querySelector('[data-zoom-close]').addEventListener('click', close);
  box.querySelector('[data-zoom-prev]').addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
  box.querySelector('[data-zoom-next]').addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
  document.addEventListener('keydown', function (e) {
    if (box.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(idx - 1);
    else if (e.key === 'ArrowRight') show(idx + 1);
  });

  var pointers = new Map();
  var startDist = 0, startScale = 1, startX = 0, startY = 0, startTx = 0, startTy = 0;
  var lastTap = 0, moved = false, swipeX = null;

  stage.addEventListener('pointerdown', function (e) {
    try { stage.setPointerCapture(e.pointerId); } catch (err) {}
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    moved = false;
    if (pointers.size === 2) {
      var p = Array.from(pointers.values());
      startDist = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
      startScale = scale; startTx = tx; startTy = ty;
    } else if (pointers.size === 1) {
      startX = e.clientX; startY = e.clientY;
      startTx = tx; startTy = ty;
      if (scale === 1) swipeX = e.clientX;
    }
  });

  stage.addEventListener('pointermove', function (e) {
    if (!pointers.has(e.pointerId)) return;
    var prev = pointers.get(e.pointerId);
    if (Math.abs(e.clientX - prev.x) + Math.abs(e.clientY - prev.y) > 5) moved = true;
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pointers.size === 2) {
      var p = Array.from(pointers.values());
      var d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
      if (startDist > 0) {
        scale = clamp(startScale * (d / startDist), 1, 4);
        tx = startTx; ty = startTy;
        if (scale <= 1) { tx = 0; ty = 0; }
        else clampPan();
        apply();
      }
    } else if (pointers.size === 1 && scale > 1) {
      tx = startTx + (e.clientX - startX);
      ty = startTy + (e.clientY - startY);
      clampPan();
      apply();
    }
  });

  function endPointer(e) {
    pointers.delete(e.pointerId);
    if (pointers.size === 0) {
      if (!moved) {
        var now = Date.now();
        if (now - lastTap < 320) {
          // double-tap: toggle zoom
          if (scale > 1) { scale = 1; tx = 0; ty = 0; }
          else { scale = 2.5; tx = 0; ty = 0; }
          apply();
          lastTap = 0;
        } else {
          lastTap = now;
        }
      } else if (swipeX !== null && scale === 1) {
        var dx = e.clientX - swipeX;
        if (dx < -60) show(idx + 1);
        else if (dx > 60) show(idx - 1);
      }
      swipeX = null;
    }
    if (pointers.size < 2) startDist = 0;
  }
  stage.addEventListener('pointerup', endPointer);
  stage.addEventListener('pointercancel', endPointer);

  stage.addEventListener('wheel', function (e) {
    e.preventDefault();
    scale = clamp(scale * (e.deltaY < 0 ? 1.15 : 0.87), 1, 4);
    if (scale <= 1) { tx = 0; ty = 0; }
    else clampPan();
    apply();
  }, { passive: false });
})();

/* ============================================================
   FIX 2026-10-23: header search (predictive) + hero video hardening
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Search panel + predictive results ---------- */
  var panel = document.getElementById('search-panel');
  var openBtn = document.querySelector('[data-search-open]');
  var closeBtn = document.querySelector('[data-search-close]');
  var input = document.querySelector('[data-search-input]');
  var results = document.querySelector('[data-search-results]');

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function setSearch(open) {
    if (!panel || !openBtn) return;
    panel.hidden = !open;
    openBtn.setAttribute('aria-expanded', String(open));
    if (open && input) { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }
  }
  if (openBtn) openBtn.addEventListener('click', function () { setSearch(panel.hidden); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setSearch(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setSearch(false); });

  var debounce = null;
  if (input && results) {
    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (debounce) clearTimeout(debounce);
      if (q.length < 2) { results.innerHTML = ''; return; }
      debounce = setTimeout(function () {
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              results.innerHTML = '<p class="search-empty">No pieces match &ldquo;' + esc(q) + '&rdquo; yet — try a category, or <a href="/pages/quote">request it custom</a>.</p>';
              return;
            }
            results.innerHTML = products.map(function (p) {
              var img = p.image ? '<img src="' + esc(p.image) + '" alt="" width="48" height="48" loading="lazy">' : '';
              var price = p.price_min ? money(Math.round(parseFloat(p.price_min) * 100)) : (p.price || '');
              return '<a class="search-hit" href="' + esc(p.url) + '">' + img +
                '<span><span class="search-hit-title">' + esc(p.title) + '</span>' +
                '<span class="search-hit-price">' + esc(price) + '</span></span></a>';
            }).join('');
          })
          .catch(function () { results.innerHTML = ''; });
      }, 250);
    });
  }

  /* ---------- Hero video: keep the poster/image if playback fails ---------- */
  var heroVideo = document.querySelector('[data-hero-video]');
  if (heroVideo) {
    var heroSection = heroVideo.closest('.hero-video');
    function showFallback() { if (heroSection) heroSection.classList.add('hero-video--fallback'); }
    heroVideo.addEventListener('error', showFallback, true);
    var src = heroVideo.querySelector('source');
    if (src) src.addEventListener('error', showFallback);
    var attempt = heroVideo.play();
    if (attempt && attempt.catch) {
      attempt.catch(function () {
        // Autoplay blocked (common on low-power mode): retry on first touch/click.
        function retry() {
          var p = heroVideo.play();
          if (p && p.catch) p.catch(showFallback);
          document.removeEventListener('touchstart', retry);
          document.removeEventListener('click', retry);
        }
        document.addEventListener('touchstart', retry, { once: true, passive: true });
        document.addEventListener('click', retry, { once: true });
      });
    }
    // If no frame data arrives quickly, the poster/background image carries the hero.
    setTimeout(function () {
      if (heroVideo.readyState < 2) showFallback();
    }, 4000);
  }
})();
